import {useSyncExternalStore} from 'react';

export function slippageBps(text:string):number|null {
 if(!/^\d+(\.\d{1,2})?$/.test(text))return null;
 const value=Math.round(Number(text)*100);
 return Number.isSafeInteger(value)&&value>=0&&value<=9999?value:null;
}
export const highSlippage=(bps:number)=>bps>=500;

// One browser-local profile; storage failures still allow editing this session.
const memory=new Map<string,string>();
const event='overture-preferences';
export function useSavedPreference(key:string,fallback:string) {
 const storageKey=`overture:${key}`;
 const read=()=>{try{return localStorage.getItem(storageKey)??memory.get(storageKey)??fallback;}catch{return memory.get(storageKey)??fallback;}};
 const subscribe=(listener:()=>void)=>{window.addEventListener('storage',listener);window.addEventListener(event,listener);return()=>{window.removeEventListener('storage',listener);window.removeEventListener(event,listener);};};
 const value=useSyncExternalStore(subscribe,read,()=>fallback);
 const set=(next:string)=>{memory.set(storageKey,next);try{localStorage.setItem(storageKey,next);}catch{}window.dispatchEvent(new Event(event));};
 return [value,set] as const;
}
export function useTradingPreferences(){
 const [bnbAmount,setBnbAmount]=useSavedPreference('trade-bnb','0.05');
 const [slippageText,setSlippageText]=useSavedPreference('trade-slippage','1');
 return {bnbAmount,setBnbAmount,slippageText,setSlippageText,bps:slippageBps(slippageText)};
}
